<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label for="account">Cost Center</label>
            <!-- <Dropdown :filter=true
              v-model="account"
              :options="costCenterLists"
              optionLabel="name"
              placeholder="Select Account"
              :showClear="true" id="account"
            /> -->
            <AutoComplete v-model="account" filterMatchMode='contains'
                          :suggestions="filteredItems" @complete="searchItem($event)"
                          field="name" ref="itm" :dropdown="true">
            </AutoComplete>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>

          <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="searchLedger" class="p-button-raised" label="Search"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="this.costCenterLedgerLists.length > 0" @click.prevent="reset"
                    class="p-button-raised p-button-warning" label="Reset"/>
          </div>
          <!-- <div class="p-field p-col-12 p-md-1 p-mt-3">
            <a href="#" @click.prevent="exportCSV()" v-if="this.costCenterLedgerLists.length > 0">
              <img src="../../../../static/img/excel.png" style="float: right;height: 3em;width: 3em;"/>
            </a>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-3">
            <a href="#" @click.prevent="exportPDF()" v-if="this.costCenterLedgerLists.length > 0">
              <img src="../../../../static/img/pdf.png" style="float: right;height: 3em;width: 3em;"/>
            </a>
          </div> -->
        </div>
      </form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable :value="costCenterLedgerLists"
                     :paginator="true" ref="po"
                     :rows="10"
                     class="p-datatable-responsive p-datatable-customers"
                     data-key="id">
            <Column header="S.N">
              <template #body="sl">
                {{ sl.index + 1 }}
              </template>
            </Column>
            <Column header="Miti"
                    field="transactionDateNepali" filterMatchMode="contains">
            </Column>
            <Column header="Date" field="transactionDate" filterMatchMode="contains">
            </Column>
            <Column header="Vou Type" field="entryType" filterMatchMode="contains">
            </Column>
            <Column header="Voucher" field="voucher" filterMatchMode="contains">
            </Column>
            <Column header="Account" field="accountName" filterMatchMode="contains">
            </Column>
            <Column header="Desc" field="remarks" filterField="remarks" filterMatchMode="contains"/>
            <Column header="Opening" bodyStyle="text-align: right" field="openingBalance" filterMatchMode="contains">
            </Column>
            <Column header="Debit" bodyStyle="color:#00a65a;text-align: right" field="debitBalance"
                    filterMatchMode="contains">
            </Column>
            <Column header="Credit" bodyStyle="color:#dd4b39;text-align: right" field="creditBalance"
                    filterMatchMode="contains">
            </Column>
            <template #empty>No record found</template>
            <Column header="Balance" field="closingBalance" bodyStyle="text-align: right" filterMatchMode="contains">
              <template #body="slotProps">
                {{ (slotProps.data.closingBalance).toFixed(2) }}
              </template>
            </Column>
            <Column header="Dr-Cr" field="drCr" filterMatchMode="contains">
            </Column>
            <Column header="Action">
              <template #body="slotProps">
                <Button v-if="slotProps.data.tranModuleType == 'PIV'"
                        class="p-button-raised p-button-warning"
                        @click="exportToPurchasePdf(slotProps.data.refrenceId)" icon="pi pi-print"/>
                <Button v-if="slotProps.data.tranModuleType == 'SIV'"
                        class="p-button-raised p-button-warning"
                        @click="exportToSalesPdf(slotProps.data.refrenceId)" icon="pi pi-print"/>
                        <Button v-if="slotProps.data.tranModuleType == 'SIV'"
                        class="p-button-raised p-button-warning"
                        @click="exportMailSalesPdf(slotProps.data.refrenceId)" icon="pi pi-send"/>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import AutoComplete from 'primevue/autocomplete'

export default {
  name: 'ledgerInquery',
  data() {
    return {
      name: '',
      fromDate: null,
      toDate: null,
      costCenterLedgerLists: [],
      account: '',
      costCenterId: 0,
      loading: false,
      englishDateEnabled: true,
      filteredItems: []
    }
  },
  computed: {
    costCenterLists() {
      return this.$store.state.costCenter.costCenterForTransactionLists
    }
  },
  mounted() {
    this.costCenterList()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async searchLedger() {
      if (this.account === '' || this.account === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select account!', life: 10000})
        return
      }
      if (this.account === '') {
        this.costCenterId = 0
      } else {
        this.costCenterId = this.account.id
      }
      let ledger = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        costCenterId: this.costCenterId
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadCostCenterLedgerList', ledger)
      this.loading = false
      this.costCenterLedgerLists = resp.data.data
    },
    async costCenterList() {
      await this.$store.dispatch('loadCostCenterForTransaction')
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        costCenterId: this.costCenterId
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/ledgerInquery' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.costCenterId + '/ledger',
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'ledgerInquery.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportPDF() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        costCenterId: this.costCenterId
      }
      axios({
        url: globalKey + '/fileDownload/printLedger/' + data.costCenterId + '/accountLedger' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + this.$store.getters.fyId + '/' + data.fromDate + '/' + data.toDate,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'ledgerInquery.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.costCenterLists]
        } else {
          this.filteredItems = this.costCenterLists.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    reset() {
      this.costCenterLedgerLists = []
      this.account = null
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    exportToPurchasePdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printPurchaseBill/' + SOHeaderId + '/purchaseInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'purchaseInvoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToSalesPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesInvoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportMailSalesPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/sendMailSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        // const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        // const link = document.createElement('a')
        // const contentDisposition = response.headers['Content-Disposition']
        // let fileName = 'salesInvoice.pdf'
        // if (contentDisposition) {
        //   const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
        //   if (fileNameMatch.length === 2) {
        //     fileName = fileNameMatch[1]
        //   }
        // }
        // link.href = url
        // link.setAttribute('download', fileName)
        // document.body.appendChild(link)
        // link.click()
        // link.remove()
        // window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Column,
    DataTable,
    InputText,
    InputMask,
    Button,
    AutoComplete
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// CostCenterLedger.vue?f87722c8